<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('locale', {
      $l: 'lang',
      locale: 'current'
    })
  }
}
</script>
